/**
 * @ngdoc Directive
 * @name vrm-validation-compare-to
 * @example
 *
 * <vrm-validation-compare-to="other.model.value.in.scope" />
 *
 */

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmValidationCompareTo', vrmValidationCompareTo)
        .directive('vrmValidationCompareToEmail', vrmValidationCompareToEmail);

    /* @ngInject */
    function vrmValidationCompareTo() {

        return {
            restrict: 'A',
            require: 'ngModel',
            link: link
        };

        /**
         * Link
         * @param $scope
         * @param $element
         * @param $attr
         * @param ngModel
         */
        function link($scope, $element, $attr, ngModel) {
            ngModel.$validators.compareTo = function(modelValue) {
                return !modelValue || modelValue.length === 0 || $attr.vrmValidationCompareTo.length === 0 || modelValue === $attr.vrmValidationCompareTo;
            };

            $attr.$observe('vrmValidationCompareTo', function(){
                ngModel.$validate();
            });
        }
    }

    function vrmValidationCompareToEmail() {

        return {
            restrict: 'A',
            require: 'ngModel',
            link: link
        };

        /**
         * Link
         * @param $scope
         * @param $element
         * @param $attr
         * @param ngModel
         */
        function link($scope, $element, $attr, ngModel) {
            ngModel.$validators.compareToEmail = function(modelValue) {
                return !modelValue || modelValue.length === 0 || $attr.vrmValidationCompareToEmail.length === 0 || modelValue === $attr.vrmValidationCompareToEmail;
            };

            $attr.$observe('vrmValidationCompareToEmail', function(){
                ngModel.$validate();
            });
        }
    }
})();
